import useValuesStore from '@/store/useValuesStore';
import useMetaStore from '@/store/useMetaStore';
import { ruleMapMatchExec } from '@/store/rulesCalc';

const useHeadButtonConfig = ({ headerBtns, btnInfo, canImport, fileModule, moduleID }) => {
  const { values, rulesMap } = useValuesStore();
  const { myRoles } = useMetaStore();
  // const calcValues = values;
  // 判断按钮权限是否显示
  const isBtnStatus = (id) => {
    const res = ruleMapMatchExec(rulesMap, id, values, myRoles);
    return res.visible;
  };
  let headButtonConfig: any[] = [];
  headButtonConfig = [
    ...(headerBtns ?? []),
    ...(btnInfo ?? []),
    ...(canImport ? ['import-btns'] : []),
    ...(fileModule ? ['upload-btns'] : []),
  ].map((btn) => {
    if (btn === 'add-btns' || btn === 'export-btns') {
      return { id: btn, ruleId: btn };
    }
    if (btn === 'delete-btns') {
      return { id: 'delete-btns', ruleId: 'mass-delete-btns' };
    }
    if (btn === 'import-btns' || btn === 'upload-btns') {
      return { id: btn, ruleId: `${moduleID}.${btn}` };
    }
    return {
      id: btn.id,
      ruleId: btn.id,
      btnConfig: btn,
    };
  });
  headButtonConfig = headButtonConfig.filter((btn) => isBtnStatus(btn?.ruleId) !== false && isBtnStatus(btn?.btnConfig?.text) !== false);
  const mainBtns = headButtonConfig.slice(0, 6);
  const moreBtns = headButtonConfig.slice(6);
  const mobileMainBtns = headButtonConfig.slice(0, 2);
  const mobileMoreBtns = headButtonConfig.slice(2);
  return { mainBtns, moreBtns, mobileMainBtns, mobileMoreBtns };
};
export default useHeadButtonConfig;
